module.exports = __webpack_public_path__ + "static/media/1001630TL.1b003dd4.jpg";